import { pageBgColor } from "@/utils/theme";
import {
	Box,
	Divider,
	Grid2,
	Paper,
	Skeleton,
	Typography,
} from "@mui/material";

export const MillOverview2Skeleton = () => {
	return (
		<Box sx={{ p: 1.5, backgroundColor: pageBgColor }}>
			<Grid2 container spacing={1}>
				<Grid2 container spacing={1} size={{ xs: 12 }} alignItems="flex-start">
					<Grid2
						size={{ xs: 12, lg: 4 }}
						display="flex"
						flexDirection="column"
						gap={1}
					>
						<Grid2
							size={{ xs: 12 }}
							display="flex"
							alignItems="center"
							gap={1.5}
						>
							<Typography variant="h5" sx={{ fontWeight: 600 }}>
								2 Mill Overview
							</Typography>
							<Skeleton variant="rounded" width={100} height={28} />
						</Grid2>
						<Box>
							<Skeleton variant="text" width={200} height={24} />
							<Skeleton variant="rounded" height={130} />
						</Box>
						<Skeleton variant="rounded" height={80} />
						<Skeleton variant="rounded" height={100} />
						<Skeleton variant="rounded" height={100} />
						<Box flexGrow={1} minHeight={70} maxHeight={140}>
							<Skeleton variant="rounded" height="100%" />
						</Box>
					</Grid2>

					<Grid2
						size={{ xs: 12, lg: 8 }}
						display="flex"
						flexDirection="column"
						gap={1}
					>
						<Grid2 container spacing={1}>
							<Grid2
								size={{ xs: 12, md: 7 }}
								display="flex"
								flexDirection="column"
								gap={1}
							>
								<Skeleton variant="rounded" height={60} />
								<Skeleton variant="rounded" height={280} />
							</Grid2>

							<Grid2
								size={{ xs: 12, md: 5 }}
								display="flex"
								flexDirection="column"
								gap={1}
							>
								<Paper
									elevation={1}
									sx={{
										p: 1,
										borderRadius: 2,
										minWidth: 0,
									}}
								>
									<Skeleton variant="text" width={120} height={24} />
									<Skeleton variant="rounded" height={40} sx={{ mb: 1 }} />
									<Skeleton variant="rounded" height={100} />
								</Paper>
							</Grid2>
						</Grid2>

						<Skeleton variant="rounded" height={220} />
						<Skeleton variant="rounded" height={220} />
					</Grid2>
				</Grid2>
			</Grid2>
		</Box>
	);
};
